/**
 * Styled Components - Created by gustavomedina on 21/03/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import Spin from 'antd/lib/spin'
import AntdProgress from 'antd/lib/progress'
import AntdButton from 'antd/lib/button'
import {
  BLUE,
  BLUE_SHADOW,
  GRAY_DARK,
  GRAY_LIGHT,
  DARKER_GRAY,
  RED_TRANSPARENT,
  WHITE,
  WHITE_BG
} from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'
import Icon from 'antd/lib/icon'

export const Container = styled.div``

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${GRAY_DARK};
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
`

export const Text = styled.span`
  height: 42px;
  width: 303.78px;
  color: ${DARKER_GRAY};
  font-size: 14px;
  line-height: 21px;
  margin-top: 10px;
`

export const StyledInput = styled(Input)`
  margin-bottom: 20px;
  margin-top: 0px;
  border-radius: 0px;
  width: 100%;
`

export const StyledInputEdit = styled(Input)`
  margin-bottom: 8px;
  margin-top: 0px;
  border-radius: 0px;
  width: 100%;
`

export const StyledSaveAs = styled.div`
  margin-bottom: 8px;
`

export const Button = styled(AntdButton)`
  height: 40px;
  width: 100%;
`

type PropsButton = {
  color: string
}

export const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  .ant-btn-primary {
    background-color: ${({ color }: PropsButton) => color};
    border-color: ${({ color }: PropsButton) => color};
    width: 100%;
  }
  .ant-btn-ghost:hover,
  .ant-btn-ghost:focus,
  .ant-btn-primary:hover {
    background-color: ${({ color }: PropsButton) => color};
    border-color: ${({ color }: PropsButton) => color};
  }
`

export const ButtonWrapperEdit = styled.div`
  margin-bottom: 10px;
  margin-top: 12px;
  .ant-btn-primary {
    background-color: ${({ color }: PropsButton) => color};
    border-color: ${({ color }: PropsButton) => color};
    width: 100%;
  }
  .ant-btn-ghost:hover,
  .ant-btn-ghost:focus,
  .ant-btn-primary:hover {
    background-color: ${({ color }: PropsButton) => color};
    border-color: ${({ color }: PropsButton) => color};
  }
`

export const OrLabel = styled.div`
  text-align: center;
  margin-bottom: 12px;
  margin-top: 16px;
  font-weight: bold;
  font-family: Avenir;
`

export const CheckWrapper = styled.div`
  margin-bottom: 10px;
  .ant-checkbox-wrapper:hover,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${BLUE};
  }
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: ${BLUE};
  }
`

export const CheckWrapperEdit = styled.div`
  margin-top: 18px;
  margin-bottom: 10px;
  .ant-checkbox-wrapper:hover,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${BLUE};
  }
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: ${BLUE};
  }
`

export const InputWrapper = styled.div`
  padding: 4px 0px;
  .ant-input:hover {
    border-color: ${BLUE};
  }

  .ant-input:focus {
    border-color: ${BLUE};
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px ${BLUE_SHADOW};
    box-shadow: 0 0 0 2px ${BLUE_SHADOW};
  }

  .ant-input::selection {
    background: ${BLUE};
  }
`

export const SpinWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${WHITE_BG};
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
`

export const StyledSpin = styled(Spin)`
  position: absolute;
  left: 0;
  right: 0;
  top: 35%;
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 12px 0 12px -38px;
`
export const buttonStyle = {
  background: RED_TRANSPARENT,
  color: WHITE,
  border: 'none',
  boxShadow: 'none'
}

export const cancelButtonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}

export const DesignIcon = styled(Icon)`
  font-size: 18px;
`

export const LoadingContainer = styled.div`
  height: 158px;
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
  font-weight: 500;
  font-family: Avenir;
`

export const CloseButton = styled(Icon)`
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 18px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const ContentLoading = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
`

export const MessageLoading = styled.div``

export const PreviewProgress = styled(AntdProgress)`
  width: 100%;
  margin-top: 8px;
`

export const ErrorMessage = styled.div`
  font-size: 14px;
  background: black;
  color: white;
  padding: 6px 10px;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 8px;
  border: 1px solid red;
  align-items: center;
  padding-left: 6px;
  display: none;
  animation: fade-in-right-alert 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right-alert {
    0% {
    transform: translateX(10px);
      opacity: 0;
    }
    100% {
    transform: translateX(0);
      opacity: 1;
    }
  }
`

export const ErrorIcon = styled(Icon)`
  color: red;
  margin-right: 10px;
`

export const ErrorLabel = styled.div``


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SaveDesign/styledComponents.tsx